const DeviceTypes = Object.freeze({
  SAMSUNG: 'SAMSUNG',
  TIZEN: 'TIZEN',
  TIZEN_TEP: 'TIZEN_TEP',
  WEBOS: 'WEBOS',
  ANDROID: 'ANDROID',
  DEFAULT: 'DEFAULT',
});

export default DeviceTypes;

